var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"532b505c074678d3d0c0e8a687ae5b1c258f1eaf"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["flowpilot-clients@bolderresearchllc"]={id:"532b505c074678d3d0c0e8a687ae5b1c258f1eaf"};
      